import { render } from "./error-alert.vue?vue&type=template&id=7c616602&scoped=true"
import script from "./error-alert.vue?vue&type=script&lang=js"
export * from "./error-alert.vue?vue&type=script&lang=js"

import "./error-alert.vue?vue&type=style&index=0&id=7c616602&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7c616602"

export default script